<!-- The stack shell. THIS FILE IS YOURS.

     There is deliberately nothing in it but a page and an outlet. That is the
     whole point of this navigation shell: one stack, no chrome, and the only
     way out of a screen is the back button on the screen itself.

     THE IonPage WRAPPER IS REQUIRED, EVEN THOUGH IT LOOKS REDUNDANT.

     This component is rendered by the ROOT outlet in App.vue, and that outlet
     transitions whatever it is given by looking for `.ion-page` on it. A shell
     whose root is a bare IonRouterOutlet gives it nothing to transition: Ionic
     warns "the view you are trying to render does not have the required
     <ion-page> component" and then renders anyway, so what you lose is the
     push/pop animation and the page lifecycle events rather than the screen.
     That combination — works, looks wrong, says nothing — is why this is worth
     a comment rather than a shrug.

     WHERE THE HEADER IS.

     Not here. Each page owns its own IonHeader, because the title, the actions
     and the back button all belong to the screen rather than to the shell. A
     header in this file would be one title for every screen in the app. -->
<template>
  <IonPage>
    <IonRouterOutlet />
  </IonPage>
</template>

<script setup>
import { IonPage, IonRouterOutlet } from '@ionic/vue';
</script>
